
export enum SortDirection {
    invalid = "invalid",
    ascending = "ascending",
    descending = "descending",
}
